// extracted by mini-css-extract-plugin
module.exports = {"container":"_19TDXKI-irRXMq7YRKDtLS","cancelBtn":"_2I7-HkIN9TFJOePKWkXqYK","icon":"_30GRLJNag0macteHCPO-K1","saveBtn":"_1aVcDTVskD2o4tClSsA9lX"};